import * as React from "react";
import { Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import moment from "moment";
import "../../../Style/dialogStyle.scss";

export default function DatePickerForDialog({ format, views, date, setDate }) {
  return (
    <Stack className="dialog-container">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
   
          format={format ? format : "dd-MM-yyyy"}
          views={views}
          onChange={setDate}
          className="date-picker-field"

          value={Boolean(date) ? new Date(date) : null}
        />
      </LocalizationProvider>
    </Stack>
  );
}
